export const SET_DLOCAL_DOCUMENT_NUMBER = 'SET_DLOCAL_DOCUMENT_NUMBER'
export const SET_ACTIVE_PRICE_PLAN_ID = 'SET_ACTIVE_PRICE_PLAN_ID'
export const TOGGLE_CHECKED_BUMP = 'TOGGLE_CHECKED_BUMP'

export const INCREASE_PRODUCT_QUANTITY = 'INCREASE_PRODUCT_QUANTITY'
export const DECREASE_PRODUCT_QUANTITY = 'DECREASE_PRODUCT_QUANTITY'

export const SET_ACTIVE_PRODUCT_VARIANT = 'SET_ACTIVE_PRODUCT_VARIANT'

export const INITIALIZE_PRODUCT_QUANTITY = 'INITIALIZE_PRODUCT_QUANTITY'

export const SET_SELECTED_SHIPPING = 'SET_SELECTED_SHIPPING'

export const SET_OFFER_PRICING = 'SET_OFFER_PRICING'

export const CHECK_COUPON_SUCCESS = 'CHECK_COUPON_SUCCESS'
export const CHECK_COUPON_FAIL = 'CHECK_COUPON_FAIL'
export const UPDATE_COUPON = 'UPDATE_COUPON'
export const SET_STRIPE_PAYMENT_METHOD = 'SET_STRIPE_PAYMENT_METHOD'
